const { Fragment, useEffect, useState } = wp.element;

import { cardPlaylist } from "../../js/playlist";
import Settings from "./settings";

import Style from "./Style";

const Edit = (props) => {
  const { attributes, setAttributes, clientId } = props;
  setAttributes({ clientId });
  const { uniqueId, audios, align, skin = "Default" } = attributes;
  const { source } = audios?.[0];
  const [player, setPlayer] = useState(null);

  useEffect(() => {
    setAttributes({ uniqueId: "h5ap" + clientId.substr(0, 9) });
  }, []);

  useEffect(() => {
    const audioPlayer = document.querySelector(`#block-${clientId}`);

    if (audioPlayer) {
      player && player.destroy();
      const pl = cardPlaylist(audioPlayer, { isAdmin: true }, audios);
      window.pp = pl;
      setPlayer(pl);
    }
  }, [attributes]);

  return (
    <Fragment>
      <Style {...props} />
      <Settings {...props} />
      <div className={`skin_${skin?.toLowerCase()} h5ap_playlist audioPlaylistCard align${align}`} id={uniqueId}>
        <audio controls playsinline>
          <source src={source} type="audio/mp3"></source>
        </audio>
      </div>
    </Fragment>
  );
};

export default Edit;
